import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Media from 'react-media';
import moment from 'moment';

import MobileBackButton from '../../UI/Mobile/MobileBackButton/MobileBackButton';
import SearchResultHeader from '../../UI/Headers/SearchResultHeader/SearchResultHeader';
import SearchResultHeaderCity from '../../UI/Headers/SearchResultHeader/SearchResultHeaderCity/SearchResultHeaderCity';
import SearchResultMobileHeading from '../../UI/Headers/SearchResultHeader/SearchResultMobileHeading/SearchResultMobileHeading';
import SearchResultHeaderBox from '../../UI/Headers/SearchResultHeader/SearchResultHeaderBox/SearchResultHeaderBox';

import { showTabletBookingEngine, toggleMobileBookingEngine, toggleTabletBookingEngine, showMobileCloseBookingEngineButton } from '../../../store/actions/index';

class HotelHeader extends Component {

    modifySearchDisplayHandler = () => {
        this.props.onToggleMobileBookingEngine();
        // if(window.innerWidth > 600 && window.innerWidth < 900) {
        //   this.props.onToggleTabletBookingEngine();
        // }
        this.props.onShowCloseMobileBookingEngineButton();
    }

    articleDisplayHandler = () => {
        // this.props.onSetLoading();
        this.props.history.goBack();
        if(window.innerWidth < 600) {
        } else {
          this.props.onShowTabletBookingEngine();
        }
    } 

    render() {

        const params = new URLSearchParams(this.props.location.search);
    
        let checkInDate = params.get('checkInDate');
        let checkOutDate = params.get('checkOutDate');
    
        checkInDate = moment(checkInDate, 'DD/MM/YYYY').format('DD MMM');
        checkOutDate = moment(checkOutDate, 'DD/MM/YYYY').format('DD MMM');

        return (
        <SearchResultHeader>
            <Media query="(max-width: 599px)">
                {matches =>
                matches ? <MobileBackButton onClick={this.articleDisplayHandler} style={{height: '3.4rem'}} /> : null}
            </Media>
            <Media query="(min-width: 599px) and (max-width: 900px)">
                {matches =>
                matches ? <MobileBackButton onClick={this.articleDisplayHandler} /> : null}
            </Media>
            <h3 className={`u-phoneHide u-fontSize13 u-fontWeightRegular u-textColorDark`}>
                <span>
                    <SearchResultHeaderCity>{params.get('city')}</SearchResultHeaderCity>
                </span>
                <span>
                    <SearchResultHeaderBox type='1'>{checkInDate} to {checkOutDate}</SearchResultHeaderBox>
                </span>
                <span>
                    <SearchResultHeaderBox type='2'>{params.get('totalAdults')} {params.get('totalAdults') > 1 ? 'Adults' : 'Adult'}  {parseInt(params.get('totalChildren'), 10) > 0 ? <span>&amp; {params.get('totalChildren')} {params.get('totalChildren') > 1 ? 'Children' : 'Child'}</span> : null}</SearchResultHeaderBox>
                </span> 
            </h3>
            <SearchResultMobileHeading>
                <span>
                    <SearchResultHeaderCity>{params.get('city')}</SearchResultHeaderCity>
                </span>
                <span className={`pl-1 pr-1`}>|</span>
                <span>
                    {checkInDate} to {checkOutDate}
                </span>
            </SearchResultMobileHeading>
        </SearchResultHeader>
        );
    }
} 

const mapStateToProps = state => {
    return {
        destination: state.hotelBookingEngine.destinationCity
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onShowTabletBookingEngine: () => dispatch(showTabletBookingEngine()),
        onToggleMobileBookingEngine: () => dispatch(toggleMobileBookingEngine()),
        onToggleTabletBookingEngine: () => dispatch(toggleTabletBookingEngine()),
        onShowCloseMobileBookingEngineButton: () => dispatch(showMobileCloseBookingEngineButton())
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HotelHeader));


// WEBPACK FOOTER //
// ./src/components/Hotel/HotelHeader/HotelHeader.js